import { useState } from 'react';

import { useFormik } from 'formik';

import { Step } from '@ui';

import { useContractNumberQuery, usePaySalom, useSendOtpQuery } from './api';
import { Conditions, RegistrationForm, Sms } from './components';
import { validationSchemaFormSalom } from './schema';
import { IFormSalomParams, IFormSalomProps } from './types';

export const FormSalom = ({
  checkout,
  isTokenization,
  enterAmount,
  type,
}: IFormSalomProps) => {
  const [initialStep, setInitialStep] = useState<number>(0);
  const [creditConditionIds, setCreditConditionIds] = useState<number[]>([]);

  const {
    mutate: checkContractNumber,
    data,
    isPending,
  } = useContractNumberQuery(isTokenization);

  const { mutate: sendOtp, isPending: isPendingSendOtp } = useSendOtpQuery();

  const { mutate: pay, isPending: isPendingPay } = usePaySalom(isTokenization);

  const handleNextStep = (): void => {
    setInitialStep(initialStep + 1);
  };

  const { handleSubmit, values, setFieldValue, errors, isValid } =
    useFormik<IFormSalomParams>({
      initialValues: { contractNumber: '' },
      validationSchema: validationSchemaFormSalom,
      onSubmit: () => {
        null;
      },
    });

  const handleChangeCreditConditionIds = (ids: number[]): void => {
    setCreditConditionIds(ids);
  };

  return (
    <div className="-ml-[150px] -mr-[150px] mt-5 rounded-xl bg-white p-24 sm:m-auto sm:rounded-none sm:px-6 sm:py-5">
      <Step
        initialStep={initialStep}
        steps={[
          <RegistrationForm
            type={type}
            key="registrationForm"
            values={values}
            isTokenization={isTokenization}
            errors={errors}
            isValid={isValid}
            checkout={checkout}
            isLoading={isPending}
            enterAmount={enterAmount}
            handleSubmit={handleSubmit}
            setFieldValue={setFieldValue}
            handleNextStep={handleNextStep}
            checkContractNumber={checkContractNumber}
          />,
          <Conditions
            key="conditions"
            sendOtp={sendOtp}
            handleNextStep={handleNextStep}
            contractNumber={values.contractNumber}
            isPendingSendOtp={isPendingSendOtp}
            conditions={data?.payload}
            handleChangeCreditConditionId={handleChangeCreditConditionIds}
          />,
          <Sms
            key="sms"
            pay={pay}
            sendOtp={sendOtp}
            isTokenization={isTokenization}
            isPendingPay={isPendingPay}
            isLoading={isPendingSendOtp}
            phone={data?.payload ? String(data?.payload[0]?.phoneNumber) : ''}
            creditConditionIds={creditConditionIds}
          />,
        ]}
      />
    </div>
  );
};
